import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import MarkdownRenderer from "../UI/MarkdownRenderer";
import VivoIcon from "../../assets/icons/vivo_logo.svg?react";
import { loadMarkdown } from "../../utils/markdownLoader";
import Loader from "../UI/Loader";

interface GuidelinesModalProps {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}

export default function GuidelinesModal({
  isOpen,
  setIsOpen,
}: GuidelinesModalProps) {
  interface ModalContent {
    frontmatter: Record<string, unknown>;
    content: string;
  }

  const [modalContent, setModalContent] = useState<ModalContent | null>(null);
  useEffect(() => {
    const getModalContent = async () => {
      const contentObj = await loadMarkdown(
        "guides/inquiry-askvivo-user-guidelines",
      );
      setModalContent(contentObj);
    };
    getModalContent();
  }, []);

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <VivoIcon width="30" height="35" />
          <p>Ask Vivo User Guidelines</p>
        </div>
      }
      centered
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      width={950}
      footer={false}
      className="overflow-y-auto"
    >
      <div className="flex flex-col px-3 text-[#2B4752] gap-2 h-[510px] overflow-y-auto hide-scrollbar">
        {modalContent ? (
          <>
            <h1 className="text-[21px] text-black font-semibold mt-3 mb-2">
              {modalContent.frontmatter.title as string}
            </h1>
            <p>{modalContent.frontmatter.description as string}</p>
            <div className="markdown">
              <MarkdownRenderer content={modalContent.content} />
            </div>
          </>
        ) : (
          <Loader type="blue" />
        )}
      </div>
    </Modal>
  );
}
